export default {
  button: 'Set password',
  newPassword: 'New password',
  confirm: 'Confirm password',
  doesntMatch: "Passwords doesn't match",
  setPassword: 'Set password'
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/auth/reset/en.js